export enum CheckpointQueueAccessType {
	General = 'General',
	PreCheck = 'PreCheck',
	Priority = 'Priority',
}
